import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  connect() {
    if (this.hasTextValue) {
      $("title").text(this.textValue)
    }
  }
}
